import "../patterns/home_page_patterns/homeMainSwiper";
import "../patterns/home_page_patterns/homeOurStory";
import "../patterns/home_page_patterns/homeNocplaces";
import "../patterns/home_page_patterns/homeOurCategories";

import "../patterns/productsSwiper";
import "../patterns/unique";

// Lazily load home page bottom content
document.addEventListener("DOMContentLoaded", function () {
  const dynamicContent = document.getElementById("dynamic-home-content");
  let hasLoaded = false;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !hasLoaded) {
          hasLoaded = true;
          loadHomeContent();
        }
      });
    },
    {
      rootMargin: "100px",
    }
  );

  if (dynamicContent) {
    observer.observe(dynamicContent);
  }

  function loadHomeContent() {
    fetch(homeAjax.ajaxurl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        action: "load_home_bottom_section",
        nonce: homeAjax.nonce,
        post_id: homeAjax.post_id,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          dynamicContent.innerHTML = data.data.html;
          dynamicContent.classList.remove("loading");

          // Dispatch custom event for bottom content loaded
          document.dispatchEvent(new CustomEvent("bottomContentLoaded"));
        }
      })
      .catch((error) => {
        console.error("Error loading content:", error);
        dynamicContent.innerHTML =
          "<p>Error loading content. Please refresh the page.</p>";
      });
  }
});
